import React from "react";
import "./Key_Pillars.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { IDS } from "../../../utils/IDS";

const Key_Pillars = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;
  const pillars = programData?.key_pillars || [];

  // const Pillars = [
  //   "/assets/images/explore_program/google.png",
  //   "/assets/images/explore_program/linux.png",
  //   "/assets/images/explore_program/python.png",
  //   "/assets/images/explore_program/mognodb.png",
  //   "/assets/images/explore_program/sql.png",
  //   "/assets/images/explore_program/linux.png",
  //   "/assets/images/explore_program/mognodb.png",
  // ];

  const Tools = [
    {
      image: "/assets/images/explore_program/icon-1.png",
      desc: "Data Analysis and Visualisation",
    },
    {
      image: "/assets/images/explore_program/icon-2.png",
      desc: "Machine Learning and AI Frameworks",
    },
    {
      image: "/assets/images/explore_program/icon-3.png",
      desc: "Data Management and Development Tools",
    },
  ];

  return (
    <section className="Key_Pillars">
      <div className="container">
        <div className="Key_Pillars_header">
          <h5 className="Key_Pillars_title">
            Key Pillars of Our Career-Driven
          </h5>
          <h5 className="Key_Pillars_subtitle"> {programData?.name}</h5>
        </div>

   {pillars.length > 0 ? (
        <div className="pillars_swiper_div">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={5}
            spaceBetween={10}
            loop={true}
            freeMode={true}
            speed={6000}
            autoplay={{
              delay: 0,
            }}
            breakpoints={{
              0: { slidesPerView: 2 },
              420: { slidesPerView: 3 },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              992: { slidesPerView: 5 },
              1200: { slidesPerView: 5 },
            }}
            className="my_swiper_holder marquee_swiper"
          >
             {pillars.map((pillar, index) =>
              // pillar.image is an array, so map over it too
              (Array.isArray(pillar.image) ? pillar.image : [pillar.image]).map((img, imgIndex) => (
                <SwiperSlide key={`${index}-${imgIndex}`}>
                  <div className="partner_logo_card">
                    <img
                      src={`${IDS.IMG_URL}${img}`}
                      alt={pillar.name || `pillar-${index}`}
                      className="brands_img"
                    />
                  </div>
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
         ) : (
          <div className="text-center my-4">
            <p className="text-muted">No Key Pillars Available</p>
          </div>
        )}

        {/* <div className="tools_div">
          <div className="row">
            {Tools.map((tool, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6 mb-3" key={index}>
                <div className="tool_card">
                  <img src={tool.image} alt={tool.desc} className="tool_img" />
                  <p className="tool_desc">{tool.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Key_Pillars;
